import { Box, Flex, Heading, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";
import Navbar from "../../components/Navbar";
import Banner from "../../components/Banner";
import DocumentCard from "../../components/DocumentCard";
import Footer from "../../components/Footer";
import { useWindowDimensions } from "../../App";
type DocumentsProps = {};
const Documents: React.FC<DocumentsProps> = () => {
  const { width } = useWindowDimensions();
  return (
    <>
      <Flex w="100%" h="95vh" direction="column">
        <Navbar />
        <Banner />
        <br />
        <br />
        <Heading
          fontWeight="extrabold"
          align="center"
          fontFamily="Poppins, sans-serif"
        >
          Documents
        </Heading>
      </Flex>
      <Box w="100%" align="center">
        <Text as="u" fontStyle="italic" fontWeight="underline" align="center">
          Click to download
        </Text>
      </Box>
      <br />
      <SimpleGrid
        gridTemplateColumns={`repeat(${
          width / 700 > 4 ? 4 : width / 700
        }, 20%)`}
        spacing={10}
        display="grid"
        align="center"
        justifyContent="center"
        m={100}
      >
        <a
          download="BEE Affidavit EME Construction Sector"
          href="pdf/BEE Affidavit-EME-Construction Sector.pdf"
        >
          <DocumentCard color="#66a3ff">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Affidavit EME Construction Sector
            </Text>
          </DocumentCard>
        </a>
        <a
          download="BEE Affidavit EME MAC Sector"
          href="pdf/BEE Affidavit-EME-MAC Sector.pdf"
        >
          <DocumentCard color="#ce0e0e">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Affidavit EME MAC Sector
            </Text>
          </DocumentCard>
        </a>
        <a
          download="BEE Affidavit QSE MAC Sector"
          href="pdf/BEE_Affidavit_QSE_MAC_Sector.pdf"
        >
          <DocumentCard color="#47c736">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Affidavit QSE MAC Sector
            </Text>
          </DocumentCard>
        </a>
        <a
          download="BEE Affidavit QSE Property Sector"
          href="pdf/BEE Affidavit-QSE-Property Sector.pdf"
        >
          <DocumentCard color="#ffb300">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Affidavit QSE Property Sector
            </Text>
          </DocumentCard>
        </a>
        <a
          download="BEE Affidavit EME Property Sector"
          href="pdf/BEE Affidavit-EME-Property Sector.pdf"
        >
          <DocumentCard color="#66b8ff">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Affidavit EME Property Sector
            </Text>
          </DocumentCard>
        </a>
        <a
          download=" BEE Affidavit EME Specialised Entity"
          href="pdf/BEE_Affidavit-EME-Specialised Entity.pdf"
        >
          <DocumentCard color="#de3c1d">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Affidavit EME Specialised Entity
            </Text>
          </DocumentCard>
        </a>
        <a
          download="BEE Affidavit QSE Specialised Entity"
          href="pdf/BEE_Affidavit-QSE-Specialised Entity.pdf"
        >
          <DocumentCard color="#72d033">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Affidavit QSE Specialised Entity
            </Text>
          </DocumentCard>
        </a>
        <a
          download="BEE Updated B-BBEE Qualifying Small Enterprise Affidavit - General"
          href="pdf/Updated B-BBEE Qualifying Small Enterprise Affidavit - General.pdf"
        >
          <DocumentCard color="#ffcc00">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Updated B-BBEE Qualifying Small Enterprise Affidavit - General
            </Text>
          </DocumentCard>
        </a>
        <a
          download="BEE Updated B-BBEE Exempted Micro Enterprise - General"
          href="pdf/Updated B-BBEE Exempted Micro Enterprise - General.pdf"
        >
          <DocumentCard color="#66ccff">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Updated B-BBEE Exempted Micro Enterprise - General
            </Text>
          </DocumentCard>
        </a>
        <a
          download="BEE Affidavit QSE MAC Sector Public Relations"
          href="pdf/Practice-Guide-01-of-2018-Determining-Validity-of-a-B-BBEE-Certificate.pdf"
        >
          <DocumentCard color="#ed5e49">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Affidavit QSE MAC Sector Public Relations
            </Text>
          </DocumentCard>
        </a>
        <a
          download="BEE Affidavit EME MAC Sector Public Relations"
          href="pdf/BEE Affidavit-QSE-MAC Sector Public Relations.pdf"
        >
          <DocumentCard color="#9cd930">
            <Text fontSize="xl" align="center" justifyContent="center">
              BEE Affidavit EME MAC Sector Public Relations
            </Text>
          </DocumentCard>
        </a>
        <a
          download="practice-guide"
          href="pdf/Practice-Guide-01-of-2018-Determining-Validity-of-a-B-BBEE-Certificate.pdf"
        >
          <DocumentCard color="#ffe600">
            <Text fontSize="xl" align="center" justifyContent="center">
              Practice guide - Determine Validate of a B-BBEE Certificate
            </Text>
          </DocumentCard>
        </a>
      </SimpleGrid>
      <Footer />
    </>
  );
};
export default Documents;
